import React, { useState, useEffect } from "react";
import { Button, Dialog, Classes, Label } from "@blueprintjs/core";
import api from "../../common/lib/api";
import RestrictionSwitch from "./RestrictionSwitch";

const INITIAL_STATE = {
  status: "init",
  app: "allowed",
  devices: [],
};

export default function ChangePassword({ token }) {
  const [show, setShow] = useState(false);
  const [state, setState] = useState(INITIAL_STATE);

  async function load() {
    const {
      data: { app },
    } = await api.get("/push-notification/app");
    const { data: devices } = await api.get("/devices");
    const { data: devicePush } = await api.get("/push-notification/devices");
    setState({
      status: "ready",
      app,
      devices,
      devicePush,
    });
  }

  useEffect(() => {
    if (show) {
      load();
    }
  }, [show]);

  async function submit() {
    await api.patch("/push-notification/app", {
      app: state.app,
    });
    for (const { deviceUuid, operate, alarm, system, diagnostic } of state.devicePush) {
      await api.patch("/push-notification/devices/" + deviceUuid, {
        operate,
        alarm,
        system,
        diagnostic,
      });
    }
    setShow(false);
    setState(INITIAL_STATE);
  }

  if (show) {
    if (state.status === "init") {
      return "Loading...";
    }
    return (
      <Dialog isOpen title="Change Notification" onClose={() => setShow(false)}>
        <div className={Classes.DIALOG_BODY}>
          <RestrictionSwitch
            label="Enable Notifications"
            value={state.app}
            onChange={(newValue) => {
              setState((st) => ({
                ...st,
                app: newValue,
              }));
            }}
          />
          {state.app === "allowed" &&
            state.devicePush.map((devicePush, index) => {
              const device = state.devices.find(
                (dev) => dev.deviceUuid === devicePush.deviceUuid
              );
              return (
                <Label key={device.deviceUuid}>
                  <strong>{device.name || devicePush.deviceUuid}</strong>
                  <RestrictionSwitch
                    label="Alarm Notifications"
                    value={devicePush.alarm}
                    onChange={(newValue) => {
                      setState((st) => {
                        const devices = st.devicePush.slice(0);
                        devices[index] = {
                          ...devices[index],
                          alarm: newValue,
                        };
                        return {
                          ...st,
                          devicePush: devices,
                        };
                      });
                    }}
                  />
                  <RestrictionSwitch
                    label="User Notifications"
                    value={devicePush.operate}
                    onChange={(newValue) => {
                      setState((st) => {
                        const devices = st.devicePush.slice(0);
                        devices[index] = {
                          ...devices[index],
                          operate: newValue,
                        };
                        return {
                          ...st,
                          devicePush: devices,
                        };
                      });
                    }}
                  />
                  <RestrictionSwitch
                    label="System Notifications"
                    value={devicePush.system}
                    onChange={(newValue) => {
                      setState((st) => {
                        const devices = st.devicePush.slice(0);
                        devices[index] = {
                          ...devices[index],
                          system: newValue,
                        };
                        return {
                          ...st,
                          devicePush: devices,
                        };
                      });
                    }}
                  />
                  <RestrictionSwitch
                    label="Test Notifications"
                    value={devicePush.diagnostic}
                    onChange={(newValue) => {
                      setState((st) => {
                        const devices = st.devicePush.slice(0);
                        devices[index] = {
                          ...devices[index],
                          diagnostic: newValue,
                        };
                        return {
                          ...st,
                          devicePush: devices,
                        };
                      });
                    }}
                  />
                </Label>
              );
            })}
          <Button onClick={submit}>Save</Button>
        </div>
      </Dialog>
    );
  }
  return (
    <Button onClick={() => setShow(true)}>Change Notification Settings</Button>
  );
}
